const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>
            Hi, I'm Shashank Shakya, a Mobile Developer. I specialize in
            technologies like Android, java, Kotlin, Flutter, Dart, and
            Firebase. With JavaScript and ReactNative, I create user-friendly Mobile
            applications. Let's work together to bring your ideas to life.
          </p>
        </>
      )
    }
  ],
  2: [
    {
      title: "2019 Bachelor's Degree",
      content: (
        <>
          <p>
            I've successfully completed my Bachelor's degree in Computer
            Applications from India, achieving proficiency in computer
            fundamentals and design patterns. With strong grades and a clean
            academic record, I am well-prepared to apply my knowledge
            effectively and contribute to innovative projects in the tech
            industry.
          </p>
        </>
      )
    },
    {
      title: "2022 Master's Degree",
      content: (
        <>
          <p>
            I've successfully completed my Master's degree in Computer
            Applications from India, achieving proficiency in computer
            fundamentals and design patterns. With strong grades and a clean
            academic record, I am well-prepared to apply my knowledge
            effectively and contribute to innovative projects in the tech
            industry.
          </p>
        </>
      )
    },

  ],
  3: [


    {
      title: "Android Developer",
      content: (
        <>
          <p>
            I worked as a Android Developer at  Kurmato softdevelop pvt. ltd. in
            Noida, India. During my 8-month tenure, I gained valuable
            expertise in computer networking, technical communication, and data
            confidentiality. This experience not only enhanced my technical
            skills but also provided an enjoyable and enriching environment for
            professional growth.
          </p>
        </>
      )
    }
  ]
};

export default subheadingsData;
